import { render } from "./InviteFriends.vue?vue&type=template&id=1c535872&scoped=true"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"

import "./InviteFriends.vue?vue&type=style&index=0&id=1c535872&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c535872"]])

export default __exports__